<app-table
  [items]="rows"
  [loading]="loading"
  [columnDefinitions]="columnDefinitions"
  [hasPagination]="false"
  [striped]="false"
  [sortable]="false"
  [allowSelectColumns]="false"
  [reorderableColumns]="false"
  [hideHeader]="true"
  [theme]="'clean'"
  [dataKey]="'id'">
  <ng-template appNamedTemplate="company" let-item>
    <div class="analysis-table__company">
      <app-user-avatar [name]="item.companyName" [size]="'small'"></app-user-avatar>
      <div class="analysis-table__company__identity">
        <strong class="analysis-table__company__name">{{ item.companyName }}</strong>
        <span class="analysis-table__company__cnpj">
          CNPJ {{ item.cnpj | mask: '99.999.999/9999-99' }}
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template appNamedTemplate="pendingDocuments" let-item>
    <span class="analysis-table__pending-pill">
      <span class="analysis-table__pending-pill__dot"></span>
      {{ item.pendingDocuments }}
    </span>
  </ng-template>

  <ng-template appNamedTemplate="rejectedDocuments" let-item>
    <span
      class="analysis-table__rejected"
      [class.analysis-table__rejected--active]="item.rejectedDocuments > 0">
      {{ item.rejectedDocuments }}
    </span>
  </ng-template>

  <ng-template appNamedTemplate="composition" let-item>
    <app-document-analysis-composition-bar
      [pending]="item.pendingDocuments"
      [approved]="item.approvedDocuments"
      [rejected]="item.rejectedDocuments"></app-document-analysis-composition-bar>
  </ng-template>

  <ng-template appNamedTemplate="action" let-item>
    <div class="analysis-table__action">
      <app-button
        [id]="'analyze-row-' + item.id"
        [label]="'Analisar'"
        [type]="'button'"
        [size]="'small'"
        (sendButtonClick)="analyze.emit(item.id)"></app-button>
    </div>
  </ng-template>
</app-table>
